class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.openElement = document.querySelector('.icon-search[predictive-search-input]');
    this.closeElement = document.querySelector('.predictive-search-input__cancel');
    this.dropDownElement = document.querySelector('.predictive-search-input__wrapper');
    this.inputElement = document.querySelector('.predictive-search-input__input');
    this.formElement = document.querySelector('.predictive-search-input__form');
    this.resultElement = document.querySelector('.predictive-search-result__wrapper');

    this.isSearchPage = this.dropDownElement.classList.contains('predictive-search-input__wrapper--page');

    this.query = this.inputElement.value || '';
    this.debounceTimer;
    this.debounceTime = 250;

    this.handleClick = this.handleClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleBodyClick = this.handleBodyClick.bind(this);
    this.handleBodySearchPageClick = this.handleBodySearchPageClick.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.fetchResults = this.fetchResults.bind(this);
    this.debounce = this.debounce.bind(this);

    this.bindEvents();
  }

  bindEvents() {
    if (this.isSearchPage) {
      this.closeElement.addEventListener('click', this.handleResetClick);
    } else {
      this.openElement.addEventListener('click', this.handleClick);
      this.closeElement.addEventListener('click', this.handleClick);
      this.formElement.addEventListener('submit', this.handleSubmit);
    }
    this.inputElement.addEventListener('input', this.handleInput);
  }

  handleResetClick(event) {
    event.preventDefault();

    this.resultElement.innerHTML = '';
    this.inputElement.value = '';
    this.query = '';
    document.body.removeEventListener('click', this.handleBodySearchPageClick);
    window.location.href = '/search?type=product,page&q=';
  }

  handleBodySearchPageClick(event) {
    this.resultElement.innerHTML = ''
  }

  handleBodyClick(event) {
    if (event.target.closest('.predictive-search-input__wrapper') === null && event.target.closest('.icon-search[predictive-search-input]') === null) {
      this.handleClick();
    }
  }

  handleClick(event) {
    if (event) {
      event.preventDefault();
    }

    document.body.classList.toggle('predictive-search-open');

    if (this.dropDownElement.getAttribute('aria-hidden') === 'false') {
      this.dropDownElement.setAttribute('aria-hidden', 'true');
      this.inputElement.value = '';
      this.query = '';
      this.resultElement.innerHTML = '';
      document.body.removeEventListener('click', this.handleBodyClick);
      return;
    }

    document.body.addEventListener('click', this.handleBodyClick);
    this.dropDownElement.setAttribute('aria-hidden', 'false');

    setTimeout(() => {

      if (this.query.length) {
        this.fetchResults();
      }
    }, 100);
  }

  async fetchResults() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}search/suggest?q=${this.query}&resources[type]=product,page&section_id=predictive-search`);
      const text = await response.text();
      if (!response.ok) {
        throw new Error(`${response.status}: ${text}`);
      }
      const resultsMarkup = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('#shopify-section-predictive-search').innerHTML;
      this.resultElement.innerHTML = resultsMarkup;

      if (this.isSearchPage) {
        document.body.removeEventListener('click', this.handleBodySearchPageClick);
        document.body.addEventListener('click', this.handleBodySearchPageClick);
      }

    } catch (error) {
      console.error(error);
    }
  }

  handleSubmit(event) {}

  handleInput(event) {
    event.preventDefault();
    this.query = event.target.value;

    if (this.query.length === 0) {
      this.resultElement.innerHTML = '';
    }

    if (!this.query.length) {
      return;
    }

    this.debounce(this.fetchResults, this.debounceTime)
  };

  debounce(callback, time) {
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(callback, time);
  };
}

customElements.define('predictive-search', PredictiveSearch);